import {closeDialog} from 'platform/components';
import {match} from 'ts-pattern';

import {useState} from 'react';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {DocumentExtractionImportError} from './components/DocumentExtractionImportError';
import {DocumentExtractionImportForm} from './components/DocumentExtractionImportForm';
import {DocumentExtractionImportSuccess} from './components/DocumentExtractionImportSuccess';

type DocumentExtractionImportDialogState = 'form' | 'success' | 'error';

interface DocumentExtractionImportDialogProps extends RequiredTestIdProps {
  dialogId: string;
}

export function DocumentExtractionImportDialog(props: DocumentExtractionImportDialogProps) {
  const [state, setState] = useState<DocumentExtractionImportDialogState>('form');

  const handleCloseDialog = () => {
    closeDialog(props.dialogId);
  };

  const handleSuccess = () => {
    setState('success');
  };

  const handleError = () => {
    setState('error');
  };

  const handleTryAgain = () => {
    setState('form');
  };

  return match(state)
    .with('form', () => (
      <DocumentExtractionImportForm
        onClose={handleCloseDialog}
        onSuccess={handleSuccess}
        onError={handleError}
        data-testid={suffixTestId('form', props)}
      />
    ))
    .with('success', () => (
      <DocumentExtractionImportSuccess
        onClose={handleCloseDialog}
        data-testid={suffixTestId('success', props)}
      />
    ))
    .with('error', () => (
      <DocumentExtractionImportError
        onTryAgain={handleTryAgain}
        data-testid={suffixTestId('error', props)}
      />
    ))
    .exhaustive();
}
